import React from 'react';
import useBreakpoint from '~/hooks/useBreakpoint';
import Steps from '~addListing/components/SideBar/Steps';
import MobileSteps from '~addListing/components/SideBar/MobileSteps';

const SideBar = () => {
  const { mobileScreen } = useBreakpoint();
  return <div>{mobileScreen ? <MobileSteps /> : <Steps />}</div>;
};

export default SideBar;
